import React from 'react';
import { motion } from 'framer-motion';
import { HerbSprig, LeafCluster } from './HealingIcons';
import { offer } from '../data/offer';
import { trackPixelEvent } from '../utils/metaPixel';
export const Section = ({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <motion.section id={id} initial={{
  opacity: 0,
  y: 24
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-80px'
}} transition={{
  duration: 0.3,
  ease: [0.23, 1, 0.32, 1]
}} className={`py-14 md:py-20 px-5 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full ${className}`} data-id="element-197" data-mp="183ue6ncz54eh">
    {children}
  </motion.section>;
export const LeafDivider = ({
  className = ''
}: {
  className?: string;
}) => <div className={`flex items-center justify-center gap-3 my-8 ${className}`} aria-hidden="true" data-id="element-198" data-mp="pfz7fnfs4quv">
    <span className="h-px w-16 md:w-28 bg-brand-greenLight/50" data-id="element-199" data-mp="1vwuhoolkm2wk" />
    <LeafCluster className="w-4 h-4 opacity-70" color="#6FA524" data-id="element-200" data-mp="20si26qp3y7vq" />
    <HerbSprig className="w-5 h-5 opacity-80" color="#2F6B34" data-id="element-201" data-mp="39kj3xv823atw" />
    <LeafCluster className="w-4 h-4 opacity-70" color="#C9A961" style={{
    transform: 'scaleX(-1)'
  }} data-id="element-202" data-mp="39hwv7s9fipa3" />
    <span className="h-px w-16 md:w-28 bg-brand-greenLight/50" data-id="element-203" data-mp="30j2t5mdbx6p5" />
  </div>;
export const SectionPill = ({
  children
}: {
  children: React.ReactNode;
}) => <div className="inline-flex items-center justify-center bg-white/80 border border-brand-purple/30 px-4 py-1.5 rounded-full mb-5 shadow-sm" data-id="element-204" data-mp="2vjq5x0ijpxm1">
    <span className="font-serif font-semibold tracking-wider text-brand-purpleDark text-xs md:text-sm" data-id="element-205" data-mp="2lueydibb5109">
      {children}
    </span>
  </div>;

/** Every purchase button on the page goes to the checkout and fires the pixel. */
export const CheckoutButton = ({
  children,
  className = '',
  fullWidth = false,
  scrollToOffer = false
}: {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  /** When true, scrolls to the US$15 offer block instead of opening checkout. */
  scrollToOffer?: boolean;
}) => <motion.a href={scrollToOffer ? '#oferta' : offer.checkoutUrl} onClick={scrollToOffer ? undefined : () => trackPixelEvent('InitiateCheckout', {
  content_name: offer.productName,
  value: offer.priceValue,
  currency: offer.currency
})} whileHover={{
  scale: 1.02
}} whileTap={{
  scale: 0.98
}} transition={{
  duration: 0.15
}} className={`cta-shimmer relative overflow-hidden inline-flex items-center justify-center text-center rounded-full purple-gradient-bg px-6 py-4 md:px-10 md:py-5 text-[15px] md:text-lg font-bold text-white shadow-[0_0_20px_rgba(47,107,52,0.35)] hover:shadow-[0_0_30px_rgba(111,165,36,0.5)] transition-shadow duration-200 ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-206" data-mp="1t7p0q8s6dui3">
    <span className="relative z-10" data-id="element-207" data-mp="2uw9ao5zbdiqp">{children}</span>
  </motion.a>;